import { useMutation, useQueryClient } from "@tanstack/react-query";
import integrationRepository from "@/repository/integrationRepository";
import { integrationQueryKeys } from "./keys";


export const useUpsertKakaoTalk = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['integration', 'kakaoTalk', 'upsert', scenarioId],
        mutationFn: async (data: any) => {
            try {
                const { data: resData } = await integrationRepository.upsertKakaoTalk(scenarioId, data);
                return resData.data;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: integrationQueryKeys.read(scenarioId) });
        }
    });
};
